.campaignPageContainer {
  font-family: "Montserrat", "Montserrat", "Times New Roman", serif;

  h2 {
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
    text-transform: none;
  }
}

.campaignPageHeader {
  position: relative;
  height: 355px;
  width: 100%;
  background-size: cover;
  background-position: center;
}

@media (max-width: 950px) {
  .campaignPageHeader {
    height: 250px;
  }
}

@media (max-width: 650px) {
  .campaignPageHeader {
    height: 165px;
  }
}

@media (max-width: 450px) {
  .campaignPageHeader {
    height: 110px;
  }
}

.donationAmount {
  display: inline-block;
  margin-bottom: 0;
  padding: 0 10px;
  color: #437a62;
  font-style: italic;
}

.reactShareContainer {
  display: flex;
  flex-direction: column;
  font-family: var(--app-font, "Montserrat", "Roboto", sans-serif);
  font-weight: 500;
  font-size: 12px;
  padding: 10px 10px 0;
  position: fixed;
  top: calc(50vh - 87px);
  right: 0;
  text-align: center;
  background-color: #fff;
  width: 75px;
  z-index: 999;
  box-shadow: 3px 3px 15px 0 rgba(0, 0, 0, 0.16);
  border-radius: 15px 0 0 15px;
  border-right: 5px solid #000;
  border-image: linear-gradient(to bottom, var(--primary-color), var(--secondaryColor)) 1
    100%;
}
.reactShareContainer:focus {
  outline: 2px solid dodgerblue;
}
.shareTextSpan {
  margin-bottom: 5px;
  color: #555;
  font-weight: 600;
  top: -5px;
  position: relative;
  font-size: 14px;
  font-family: "RobotoRegular", sans-serif;
  margin-top: 10px;
  display: block;
}
.buttonsContainer {
  display: flex;
  gap: 1em;
  justify-content: center;
}
@media (max-width: 950px) {
  .reactShareContainer {
    display: none;
  }
}

.reactShareContainerMobile {
  display: block;
  margin-top: 20px;
}
.reactShareContainerMobile:focus {
  outline: 2px solid dodgerblue;
}
@media (min-width: 950px) {
  .reactShareContainerMobile {
    display: none;
  }
}
.reactShareContainerMobile .textSpan {
  margin-bottom: 5px;
  color: #555;
  font-weight: 500;
}
.reactShareContainerMobile .buttonsContainer {
  justify-content: space-evenly;
  margin-top: 10px;
}
.reactShareContainerMobile button {
  margin-right: 5px;
  margin-left: 5px;
}

.campaignOverlay {
  position: absolute;
  height: 355px;
  width: 100%;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 1) 100%);
  opacity: 0.15;
  top: 0;
  left: 0;
}

.newCampaignPage {
  width: 100%;
  background: #f2f2f2;
  background-repeat: no-repeat;
  transition-property: margin-top;
}

.number {
  font-family: "Droid Sans Mono", monospace;
  font-size: 32px;
  color: var(--primary-text-color, #6675b2);
  -webkit-text-stroke: 1px rgba(0, 0, 0, 0);
  font-weight: bold;
}

.newCampaignCtaContainer {
  color: #fff;
  padding: 0 0 30px 0;
  width: 100%;
  margin-top: -100px;
  position: relative;
}
@media (max-width: 950px) {
  .newCampaignCtaContainer {
    text-align: center;
    display: flex;
    flex-direction: column;
    padding-top: 216px;
    padding-bottom: 0;
  }
}

.newCampaignHeaderContainer {
  background-color: #fff;
  width: 1200px;
  box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.07);
  margin-right: auto;
  margin-left: auto;
  border-radius: 20px;
  height: 400px;
  margin-top: -25px;
  padding-bottom: 25px;
}
@media (max-width: 950px) {
  .newCampaignHeaderContainer {
    text-align: center;
    width: 90%;
    height: auto;
  }
}

.inlineContainer {
  display: flex;
}
@media (max-width: 950px) {
  .inlineContainer {
    flex-direction: column;
  }
}

.mainGoalContainer {
  padding-right: 20px;
  margin-right: 45px;
  width: 41%;
}
@media (max-width: 950px) {
  .mainGoalContainer {
    width: 100%;
    padding-right: 0;
    margin-right: 0;
  }
}

.newCampaignImg {
  margin-top: 20px;
  margin-left: 30px;
  height: 128px;
  width: 128px;
  object-fit: cover;
  border-radius: 50%;
}
@media (max-width: 950px) {
  .newCampaignImg {
    margin: auto;
    margin-top: -26px;
    text-align: center;
  }
}

.profileImg {
  position: absolute;
  top: 0;
  right: 5%;
  box-shadow: 0 2px 3px 2px rgba(0, 0, 0, 0.5);
}

.newCampaignHeaderColor {
  font-size: 22px;
  margin-left: 23px;
  margin-top: 20px;
  color: #555;
  font-weight: bold;
  text-transform: none;
}
@media (max-width: 950px) {
  .newCampaignHeaderColor {
    max-width: 100%;
    text-align: center;
    margin-left: 0;
  }
}

.goalProgressContainer {
  display: block;
  margin-left: 30px;
  margin-top: 15px;
  width: 100%;
}
@media (max-width: 950px) {
  .goalProgressContainer {
    margin-left: 0;
    padding: 16px;
  }
}

.totalRaisedNumber {
  font-size: 36px;
  font-family: var(--app-font, "Montserrat", "Roboto", sans-serif);
  font-weight: 700;
  margin-right: 1em;
}

.goal {
  display: flex;
  margin-top: 0.5em;
  font-size: 1.1em;
  color: #555;
}
@media (max-width: 950px) {
  .goal {
    justify-content: center;
  }
}
.goalText {
  font-size: 16px;
  color: #555;
  font-family: var(--app-font, "Montserrat", "Roboto", sans-serif);
  font-weight: 400;
  font-weight: bold;
  -webkit-text-stroke: 1px rgba(0, 0, 0, 0);
}
.goalNumber {
  font-weight: bold;
  font-size: 16px;
  color: #555;
}

.infoContainer {
  margin-left: 30px;
}

@media (max-width: 950px) {
  .infoContainer {
    margin-left: 0;
    margin-left: 5%;
    margin-right: 5%;
  }
}

.supporters {
  padding-bottom: 10px;
  text-align: left;
  font-size: 1.1em;
}
@media (max-width: 950px) {
  .supporters {
    text-align: center;
    padding-left: 16px;
    padding-right: 16px;
    margin-bottom: 20px;
  }
}

.textSpan {
  font-size: 16px;
  color: #555;
  font-family: var(--app-font, "Montserrat", "Roboto", sans-serif);
  font-weight: 400;
  margin-bottom: 5px;
  margin-left: 5px;
  font-weight: 500;
  top: -5px;
  position: relative;
}

.primaryColorText {
  color: var(--primary-text-color, #000);
}

.thanks {
  font-family: "Montserrat", "Montserrat", sans-serif;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 0.5em;
  text-align: center;
  margin-top: 30px;
  color: var(--primary-text-color, #000);
  text-transform: none;
}

.supporterMessagesContainer {
  position: relative;
  overflow-y: hidden;
  height: 350px;
  margin-bottom: 20px;
}
.supporterMessagesContainer:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  height: 75px;
  width: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
}

.buttonContainerPausePlay {
  display: flex;
  justify-content: center;
  margin-bottom: 7px;
  gap: 1em;
  margin-top: 0.5em;
}

.fbMessages {
  padding: 0 10px;
  position: relative;
  list-style: none;
  margin: 0;
}
.fbMessages > p {
  border-bottom: 2px solid #fff;
  padding: 5px 10px;
}

.fbMessage {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.75em;
  background: #fff;
  border-radius: 4px;
  padding: 0.5em;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}
.fbMessage div {
  display: flex;
  align-items: center;
}
.fbMessage img {
  border-radius: 25px;
  float: left;
  max-width: 50px;
}
.fbMessage:not(:last-of-type):after {
  position: absolute;
  content: "";
  width: 100%;
  bottom: 0;
  height: 1px;
  left: 0;
}

.fbUserInfo {
  float: left;
  padding-left: 7px;
}

.fbUserName {
  color: #446f9e;
  text-transform: capitalize;
}

.msgContent {
  clear: both;
  margin: 0.25em 0 0 0;
  font-size: 0.95em;
  color: #555;
}

.giftButton {
  border-radius: 40px;
  background-color: var(--primary-color, #1e4795);
  color: white;
  font-family: var(--app-font);
  font-weight: 400;
  display: flex;
  justify-content: center;
}

.giftButton:hover {
  background-color: var(--primary-color-seethrough, #1e4795);
  color: white;
}

.contribute {
  margin-top: 1em;
}

.newCampaignMediaContainer {
  width: 59%;
}
@media (max-width: 950px) {
  .newCampaignMediaContainer {
    width: 95%;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }
}

.campaignDetails {
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 950px) {
  .campaignDetails {
    width: 90%;
  }
}

.newMediaAndSupporterInfo {
  width: 1200px;
  padding-top: 20px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 100px;
}
@media (max-width: 1120px) {
  .newMediaAndSupporterInfo {
    width: 100%;
  }
}

.campaignTextContent {
  width: 100%;
  min-height: 500px;
  padding: 16px;
  box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.07);
  background-color: #fff;
  border-radius: 16px 16px 20px 20px;
  margin-bottom: 1em;
}

.campaignTextContent img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 950px) {
  .campaignTextContent {
    margin-top: 16px;
  }
}

.gradientLine {
  height: 8px;
  border-radius: 20px 20px 0 0;
  margin-top: -16px;
  margin-left: -15px;
  margin-right: -15px;
}

.hideTitle {
  display: none;
}

/*break*/

@media (max-width: 1755px) {
  :global(#react-container) .reactShareContainer {
    display: none;
  }

  :global(#react-container) .campaignTextContent {
    margin-top: 16px;
  }

  :global(#react-container) .newCampaignCtaContainer {
    text-align: center;
    display: flex;
    flex-direction: column;
    padding-top: 216px;
    padding-bottom: 0;
  }

  :global(#react-container) .newCampaignHeaderContainer {
    text-align: center;
    width: 90%;
    height: auto;
  }

  :global(#react-container) .inlineContainer {
    flex-direction: column;
  }

  :global(#react-container) .mainGoalContainer {
    width: 100%;
    padding-right: 0;
    margin-right: 0;
  }

  :global(#react-container) .goal {
    justify-content: center;
  }

  :global(#react-container) .goalProgressContainer {
    margin-left: 0;
    padding: 16px;
  }

  :global(#react-container) .goalProgressContainer :global(.progress-bar-container) {
    margin-left: auto;
    margin-right: auto;
    width: 95%;
  }

  :global(#react-container) .newCampaignHeaderColor {
    max-width: 100%;
    text-align: center;
    margin-left: 0;
  }

  :global(#react-container) .newCampaignImg {
    margin: auto;
    margin-top: -26px;
    text-align: center;
  }

  :global(#react-container) .newMediaAndSupporterInfo {
    width: 100%;
  }

  :global(#react-container) .campaignDetails {
    width: 90%;
  }

  :global(#react-container) .newCampaignMediaContainer {
    width: 95%;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }

  :global(#react-container) .supporters {
    text-align: center;
    padding-left: 16px;
    padding-right: 16px;
    margin-bottom: 20px;
  }

  :global(#react-container) .infoContainer {
    margin-left: 0;
    margin-left: 5%;
    margin-right: 5%;
  }
}

@media (max-width: 1336px) {
  :global(.col-md-4) {
    width: 100%;
  }

  :global(.col-md-8) {
    width: 100%;
  }
}
